import { useSyncExternalStore } from "react"

export interface DeviceLayout {
    isMobile: boolean
    isLandscape: boolean
}

export function useDeviceLayout(): DeviceLayout {
    const isMobile = useSyncExternalStore(
        (cb) => {
            const mq = window.matchMedia("(pointer: coarse)")
            mq.addEventListener("change", cb)
            return () => mq.removeEventListener("change", cb)
        },
        () => window.matchMedia("(pointer: coarse)").matches,
        () => false
    )

    const isLandscape = useSyncExternalStore(
        (cb) => {
            const mq = window.matchMedia("(orientation: landscape)")
            mq.addEventListener("change", cb)
            return () => mq.removeEventListener("change", cb)
        },
        () => window.matchMedia("(orientation: landscape)").matches,
        () => true
    )

    return { isMobile, isLandscape }
}
